<script lang="ts">
	import { browser } from '$app/environment';
	import { afterUpdate, onDestroy } from 'svelte';

	export let text = '';
	type positions = 'left' | 'center' | 'right';
	export let position: positions = 'center';
	export let unmountDelay = 0;
	export let contentZIndex = 0;

	let tooltipContentRef: HTMLElement | null = null;
	let tooltipRef: HTMLElement | null = null;
	let isOpen = false;
	let height = 0;
	let left = 0;

	const toggleIsOpen = () => {
		isOpen = !isOpen;
	};

	afterUpdate(() => {
		if (tooltipContentRef && tooltipRef) {
			const contentBoundary = tooltipContentRef.getBoundingClientRect();
			const targetBoundary = tooltipRef.getBoundingClientRect();
			height = targetBoundary.top + window.scrollY - contentBoundary.height;
			if (position == 'center') {
				left = targetBoundary.left - contentBoundary.width / 2 + targetBoundary.width / 2;
			} else if (position == 'left') {
				left = targetBoundary.left - 20;
			} else if (position == 'right') {
				left = targetBoundary.right + 20;
				height =
					targetBoundary.top +
					+window.scrollY +
					targetBoundary.height / 2 -
					contentBoundary.height / 2;
			}
		}
	});

	let isTooltipHovered = false;
	const tooltipHovered = () => {
		isTooltipHovered = true;
	};
	const tooltipNotHovered = () => {
		isTooltipHovered = false;
		unmount();
	};

	const mount = () => {
		if (tooltipContentRef && tooltipRef) {
			document.body.appendChild(tooltipContentRef);
			tooltipContentRef.style.display = 'block';
			toggleIsOpen();
		}
	};
	const unmount = () => {
		if (document.body.contains(tooltipContentRef) && !isTooltipHovered && tooltipContentRef) {
			if (unmountDelay) {
				setTimeout(() => {
					if (document.body.contains(tooltipContentRef) && tooltipContentRef) {
						tooltipContentRef.remove();
					}
				}, unmountDelay);
			} else {
				tooltipContentRef.remove();
			}
		}
		toggleIsOpen();
	};
	onDestroy(() => {
		if (browser) {
			unmount();
		}
	});
</script>

<svelte:body on:scroll={toggleIsOpen} />
<div class="tooltipWrapper">
	<!-- svelte-ignore a11y-mouse-events-have-key-events -->
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div
		class="tooltipRef"
		on:mouseover={mount}
		on:mouseout={unmount}
		on:wheel={unmount}
		bind:this={tooltipRef}>
		<slot />
	</div>
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div
		class="tooltipContent"
		on:mouseenter={tooltipHovered}
		on:mouseleave={tooltipNotHovered}
		bind:this={tooltipContentRef}
		style={`
			position: absolute;
			transform: translate(${left}px,${height}px);
			z-index: ${contentZIndex || 'var(--z-index-Modal'}
			`}>
		<!-- TODO: Replace with slot -->
		<span>{text}</span>
		<slot name="content" />
	</div>
</div>

<style>
	.tooltipRef {
		position: relative;
		block-size: 100%;
		inline-size: fit-content;
	}

	.tooltipWrapper {
		position: relative;
	}

	.tooltipContent {
		display: none;
		z-index: var(--z-index-Modal);
		inline-size: max-content;
		max-inline-size: 200px;
		padding-block: var(--gutterSmall);
		padding-inline: var(--gutterSmall);
		border-radius: 5px;
		background-color: var(--grayDarkest);
		inset-block-start: 0;
		inset-inline-start: 0;
	}

	.tooltipContent :global(*) {
		color: var(--grayLight);
		font-size: var(--fontSizeSmaller);
		line-height: 1.3;
	}

	.tooltipContent :global(a) {
		color: var(--grayDark);
		text-decoration: underline;
	}
</style>
